/**
 * @description 端相关跳转事件
 * @author qinchunzhen
 */

// aio 全局变量
// 小程序内跳转司机端页面事件提示页面 || 乘客端打开司机端页面提示页面
const defaultDriverHtml = 'https://s.didi.cn/rGM7o'
// 浏览器未调起端app默认跳转页
const defaultBrowserHtml = 'https://s.didi.cn/rrAKq'
// 司机端打开乘客端页面提示页面
const defaultPassengerHtml = 'https://s.didi.cn/efeLZ'
// 延迟时间
const pastTime = 2500
/**
 * 跳转
 * @param {Object} eventData 事件配置
*/
export default function (eventData = {}) {
    const bridgeType = eventData.bridgeType

    console.log('aswdfwesf:', K)
    // loading层

    // 乘客端 司机端 ｜ 小程序端 ｜ 浏览器端

    // 乘客端
    if (bridgeType === 'passenger') {
        if (K.web.is('passenger')) {
            // 乘客端内打开顶导页（转化为小写路径，因为端内也会转化为小写路径，但是【车生活】ios端未做处理，所以统一在跳转页面时转换）
            K.bridge.call('switchToBusinessPage', {
                navi_url: eventData.urlScheme.toLocaleLowerCase()
            }, () => {})
        } else if (window.__wxjs_environment === 'miniprogram') {
            // 容错配置小程序地址未以 / 开头
            let path = eventData.webapp
            if (path.indexOf('/') !== 0) {
                path = `/${eventData.webapp}`
            }
            // 如果环境中没有注册wxsdk，则引入K.js分享去注册wxsdk
            if (!window.wx) {
                K.setShare()
                setTimeout(() => {
                    jumpWxApp(path)
                }, 50)
            } else {
                jumpWxApp(path)
            }
        } else if (K.web.is('driver')) {
            // 跳转到default页面（请在[滴滴出行]端内打开该活动页面）
            window.location.href = defaultPassengerHtml
        } else {
            jumpBrowser(eventData.urlScheme)
        }
    }

    // 司机端
    if (bridgeType === 'driver') {
        if (K.web.is('driver')) {
            // 判断urlScheme是否支持端内打开
            if (eventData.isBridge) {
                window.location.href = eventData.urlScheme
            }
        } else if (window.__wxjs_environment === 'miniprogram') {
            // 跳转到default页面（请在[滴滴车主]端内打开该活动页面）
            window.location.href = defaultDriverHtml
        } else if (K.web.is('passenger')) {
            // 跳转到default页面（请在[滴滴车主]端内打开该活动页面）
            window.location.href = defaultDriverHtml
        } else {
            jumpBrowser(eventData.urlScheme)
        }
    }
}

// 微信小程序跳转
function jumpWxApp (path) {
    window.wx.miniProgram.navigateTo({
        url: path
    })
}

// 浏览器跳转
function jumpBrowser (urlScheme) {
    try {
        // 判断系统环境，ios端直接跳转，其他端调用iframe跳转
        if (K.web.is('ios')) {
            window.location.href = urlScheme
        } else {
            createIframe(urlScheme)
        }
    } catch (e) {
        jump()
    }
    defaultJump(+new Date())
}

// 打底处理
function defaultJump (openTime) {
    window.jumpBrowserTimer = window.setTimeout(() => {
        if ((+new Date() - openTime) > pastTime) {
            jump()
        }
    }, pastTime)
}

// 浏览器默认跳转
function jump () {
    window.location.href = defaultBrowserHtml
}

// 兼容Android跳转页面
function createIframe (url) {
    const iframe = document.createElement('IFRAME')
    iframe.scrolling = 'no'
    iframe.frameBorder = 0
    iframe.style.width = '0'
    iframe.style.height = '0'
    iframe.style.display = 'none'
    document.body.appendChild(iframe)
    iframe.src = url
}
